import { ComponentProps, ComponentType } from 'react';

import {
    AdditionalContentOfferModal,
    CancellationReasonModal,
    CanNotLoginModal,
    CompletePersonalPlanModal,
    ConfirmationModalWithDiscount,
    CopyCodeErrorModal,
    DiscountModal,
    ExpiredSubscriptionDiscountErrorModal,
    FitnessLevelModal,
    FreeMonthModal,
    GoalModal,
    NoConnectionModal,
    NoLogInModal,
    PauseModal,
    ProblemZonesModal,
    QuitWorkoutModal,
    ReminderModal,
    ResizableNotificationModal,
    RestoreSubscriptionModal,
    RetryErrorModal,
    ReturnModal,
    ServerErrorModal,
    SuccessModal,
    WithLoaderModal,
} from './modalsExports';

export enum ModalName {
    DiscountModal = 'DiscountModal',
    CancellationReasonModal = 'CancellationReasonModal',
    WithLoaderModal = 'WithLoaderModal',
    SuccessModal = 'SuccessModal',
    NoConnectionModal = 'NoConnectionModal',
    QuitWorkoutModal = 'QuitWorkoutModal',
    CompletePersonalPlanModal = 'CompletePersonalPlanModal',
    GoalModal = 'GoalModal',
    ProblemZonesModal = 'ProblemZonesModal',
    FitnessLevelModal = 'FitnessLevelModal',
    RestoreSubscriptionModal = 'RestoreSubscriptionModal',
    CanNotLoginModal = 'CanNotLoginModal',
    ReminderModal = 'ReminderModal',
    FreeMonthModal = 'FreeMonthModal',
    RetryErrorModal = 'RetryErrorModal',
    AdditionalContentOfferModal = 'AdditionalContentOfferModal',
    PauseModal = 'PauseModal',
    ConfirmationModalWithDiscount = 'ConfirmationModalWithDiscount',
    ReturnModal = 'ReturnModal',
    ResizableNotificationModal = 'ResizableNotificationModal',
    ExpiredSubscriptionDiscountErrorModal = 'ExpiredSubscriptionDiscountErrorModal',
    NoLogInModal = 'NoLogInModal',
    ServerErrorModal = 'ServerErrorModal',
    CopyCodeErrorModal = 'CopyCodeErrorModal',
}

export type ModalPropsType = {
    [ModalName.DiscountModal]: ComponentProps<typeof DiscountModal>;
    [ModalName.CancellationReasonModal]: ComponentProps<typeof CancellationReasonModal>;
    [ModalName.WithLoaderModal]: ComponentProps<typeof WithLoaderModal>;
    [ModalName.SuccessModal]: ComponentProps<typeof SuccessModal>;
    [ModalName.NoConnectionModal]: ComponentType<typeof NoConnectionModal>;
    [ModalName.QuitWorkoutModal]: ComponentProps<typeof QuitWorkoutModal>;
    [ModalName.CompletePersonalPlanModal]: ComponentProps<typeof CompletePersonalPlanModal>;
    [ModalName.GoalModal]: ComponentProps<typeof GoalModal>;
    [ModalName.ProblemZonesModal]: ComponentProps<typeof ProblemZonesModal>;
    [ModalName.FitnessLevelModal]: ComponentProps<typeof FitnessLevelModal>;
    [ModalName.RestoreSubscriptionModal]: ComponentProps<typeof RestoreSubscriptionModal>;
    [ModalName.CanNotLoginModal]: ComponentProps<typeof CanNotLoginModal>;
    [ModalName.ReminderModal]: ComponentProps<typeof ReminderModal>;
    [ModalName.FreeMonthModal]: ComponentProps<typeof FreeMonthModal>;
    [ModalName.RetryErrorModal]: ComponentProps<typeof RetryErrorModal>;
    [ModalName.AdditionalContentOfferModal]: ComponentProps<typeof AdditionalContentOfferModal>;
    [ModalName.PauseModal]: ComponentProps<typeof PauseModal>;
    [ModalName.ConfirmationModalWithDiscount]: ComponentProps<typeof ConfirmationModalWithDiscount>;
    [ModalName.ReturnModal]: ComponentProps<typeof ReturnModal>;
    [ModalName.ResizableNotificationModal]: ComponentProps<typeof ResizableNotificationModal>;
    [ModalName.ExpiredSubscriptionDiscountErrorModal]: ComponentProps<typeof ExpiredSubscriptionDiscountErrorModal>;
    [ModalName.NoLogInModal]: ComponentProps<typeof NoLogInModal>;
    [ModalName.ServerErrorModal]: ComponentProps<typeof ServerErrorModal>;
    [ModalName.CopyCodeErrorModal]: ComponentProps<typeof CopyCodeErrorModal>;
};

export type ModalsMapType = {
    [key in ModalName]: ComponentType<ModalPropsType[key]>;
};
